import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';

export const CookieConsentBanner = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(() => !localStorage.getItem('mintedCookieConsent'));

  // Never cover the chat composer or checkout flow
  if (!visible || /^\/messages\/.+/.test(location.pathname) || location.pathname.startsWith('/checkout')) return null;

  const accept = () => {
    localStorage.setItem('mintedCookieConsent', 'true');
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-stone-900 text-white px-4 py-3 safe-area-bottom" data-testid="cookie-consent-banner">
      <div className="max-w-lg mx-auto flex items-center gap-3">
        <p className="text-xs text-stone-300 flex-1 leading-snug">
          We use essential cookies to keep you signed in and remember your preferences. No advertising trackers.{' '}
          <Link to="/privacy" className="underline text-emerald-400">Privacy Policy</Link>
        </p>
        <Button size="sm" onClick={accept} className="bg-emerald-700 hover:bg-emerald-600 h-8 px-4 text-xs rounded-lg flex-shrink-0" data-testid="cookie-consent-accept">
          Got it
        </Button>
      </div>
    </div>
  );
};
